// this is a custom hook that makes stuff fade/slide into view as you scroll down
// useeffect lets us run side-effect code after the component shows up
import { useEffect } from 'react';

// call this once inside a page and it wires up the whole scroll-reveal thing
export function useScrollReveal() {
  // the empty [] at the bottom means "run this once when the page mounts, then leave it alone"
  useEffect(() => {
    // an intersectionobserver watches elements and tells us when they enter the screen
    const observer = new IntersectionObserver(
      // this callback runs every time a watched element crosses the visibility line
      (entries) => {
        // entries is a list of elements that just changed visibility
        entries.forEach((entry) => {
          // if the element is now on screen...
          if (entry.isIntersecting) {
            // ...slap a 'visible' class on it and the css handles the actual animation
            entry.target.classList.add('visible');
          }
        });
      },
      // threshold 0.12 = fire once about 12% of the element is showing
      // rootmargin nudges the trigger line up 40px so it reveals a touch early
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    // grab every element we want to animate (they have one of these classes)
    const targets = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    // start watching each one
    targets.forEach((el) => observer.observe(el));

    // cleanup: when the page goes away, stop the observer so we don't leak memory
    return () => observer.disconnect();
  }, []);
}
